import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import OspreyApi from '../../actions/osprey-api'

export const UserInfoPropType = PropTypes.shape({
    email: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    siloCount: PropTypes.number.isRequired
})

export default function withUserInfo(ChildComponent) {

    class WithUserInfoWrapper extends Component {
        static propTypes = {
            meResult: PropTypes.object
        }

        constructor(props) {
            super(props)
        }

        render() {
            const { meResult, ...otherProps } = this.props

            if (!meResult || !meResult.content) {
                return null
            }

            return (
                <ChildComponent userInfo={meResult.content.userInfo} {...otherProps} />
            )
        }
    }

    return connect(mapStateToProps)(WithUserInfoWrapper)
}

const mapStateToProps = (state) => {
    const { contentByKey } = state
    const api = new OspreyApi()

    return {
        meResult: api.me.info.getState(contentByKey)
    }
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-user-info.js